import Marquee from "react-fast-marquee";

const items = [
  "Sydney-wide emergency dispatch",
  "Don't start your engine",
  "No fix · no fee",
  "24/7 rescue",
  "Petrol in diesel",
  "Diesel in petrol",
  "We come to you",
  "Fully insured",
];

export const TickerRibbon = () => (
  <div data-testid="ticker-ribbon" className="border-y border-black/10 bg-[#22303C] py-3.5">
    <Marquee speed={38} gradient={false}>
      {items.map((t, i) => (
        <span key={i} className="mx-5 flex items-center gap-5 text-sm font-medium uppercase tracking-[0.15em] text-white/75">
          {t}
          <span className="h-1.5 w-1.5 rounded-full bg-[#1F7A6B]" />
        </span>
      ))}
    </Marquee>
  </div>
);
